<template>
   <div class="layout">
        <div class="layout__header">
            <h3>Establecimientos</h3>
        </div>
        <k-table :filterStatus="filterStatus" @crear="crear" :createButton="createButton" 
        :editButton="false" :deleteButton="false" ref="listaLocalidades" 
        @seleccionar="seleccionar" :path="url + '/localidades/search'" :columns="[
            {
                display : '# Establecimiento',
                value : 'numero_localidad'
            },
            {
                display : 'Descripción',
                value : 'descripcion'
            },
            {
                display : 'Dirección',
                value : 'direccion'
            }
        ]">
        </k-table>
        <modal :width="'80%'" height="auto" :scrollable="true"  name="crearLocalidad">
            <localidad :searchButton="false" @created="createdLocalidad"></localidad>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        createButton : {
            type : Boolean,
            required : false,
            default : true
        },
        filterStatus : {
            type : Boolean,
            required : false,
            default : true
        }
    },
    data : function () {
        return {
            currentIndex : -1,
            currentLocalidad : null,
            url : url
        }
    },
    methods : {            
            seleccionar : function(currentLocalidad) {
                this.$emit('selected', currentLocalidad);
                this.$emit('cerrarModal');
            },
             crear : function () {
                this.$modal.show('crearLocalidad');
            },
            createdLocalidad: function (localidad) {
                this.$refs.listaLocalidades.actualizarLista(localidad);
                this.$modal.hide('crearLocalidad');
            }
    }

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/localidades/ListaLocalidades.vue